import { render, staticRenderFns } from "./SearchCard.vue?vue&type=template&id=8d2b86dc&scoped=true"
import script from "./SearchCard.vue?vue&type=script&lang=js"
export * from "./SearchCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2b86dc",
  null
  
)

export default component.exports